import React from "react";
import './styles/button_style.css';
import { Button } from "primereact/button";

const ButtonComponent = ({className= '', children, ...props}) => {
    return (
        <Button {...props} className={'btn-horizontal-gradient w-full py-2 border-round-2xl text-base align-items-center justify-content-center gap-2' + className} />
    );
};

export default ButtonComponent;